import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=04dea1f0"
import script from "./demo.vue?vue&type=script&lang=ts"
export * from "./demo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports